import { type FunctionalComponent, h } from '@stencil/core';
import type { ISearchResultTag } from '../types/subcomponents-types.type';
import {CARD_TYPE} from '../../../../strategies/utils/variables';
import type {CardStrategyService} from '../../../../strategies/CardStrategyService';

export const SearchResultTag: FunctionalComponent<ISearchResultTag> = ({
  ...props
}) => {
    const cardStrategy:CardStrategyService = props.strategies.for(CARD_TYPE);
    const Tag = cardStrategy.makeCard(props.doc);
    const properties = cardStrategy.getCardProps(props.doc, {});

    return (
      <Tag
        doc={props.doc}
        {...properties}
        resultRenderer={props.resultRenderer}
        resultClickHandler={(e) => {
            props.resultClickAnalytics(
              e,
              props.index,
              props.doc.url || props.doc.openUrl,
              props.doc.commStatus,
              props.doc['actions'],
              props.doc['_click'],
            );
        }}
        labelProvider={(e, f) => props.labelProvider(e, f)}
        index={props.index}
        country={props.country}
        language={props.language}
        gridView={props.gridView}
        isEcommerceMode={props.isEcommerceMode}
        isDashboardView={props.isDashboardView}
        eShop={props.eShop}
        rtl={props.rtl}
        strategies={props.strategies}
        isDashboardListVariant={props.isDashboardListVariant}
        lazyLoadImages={props.lazyLoadImages}
        isSubstitutionTool={props.isSubstitutionTool}
        eolProductsNumber={props.eolProductsNumber}
        wcEventData={props.wcEventData}
        isUnifiedCheckout={props.isUnifiedCheckout}
        marketingProductBadgesFilters={props.marketingProductBadgesFilters}
        isCarousel={props.isCarousel}
      />
    );
};
